import { c as _c } from "react/compiler-runtime";
import { type FC, type ReactNode } from "react";
interface SectionTitleProps {
  children: ReactNode;
}
export const SectionTitle: FC<SectionTitleProps> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <h2 className="text-2xl md:text-3xl font-black text-slate-900 dark:text-white uppercase tracking-tight mb-8 flex items-center gap-3">{children}</h2>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};